import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/keyword/importer/keywordImporterSelectors';
import KeywordService from 'src/modules/keyword/keywordService';
import fields from 'src/modules/keyword/importer/keywordImporterFields';
import { i18n } from 'src/i18n';

const keywordImporterActions = importerActions(
  'KEYWORD_IMPORTER',
  selectors,
  KeywordService.import,
  fields,
  i18n('entities.keyword.importer.fileName'),
);

export default keywordImporterActions;